import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);

  // While loading auth, return null - the HTML spinner in index.html stays visible
  if (loading) {
    return null;
  }

  // If not authenticated, redirect to login (Login component will hide the loader)
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // If authenticated, render the protected component (TicketBoard will hide the loader when ready)
  return children;
};

export default ProtectedRoute;
